import React from "react";
import { SideBar } from "./sidebar";
import {
  createOfficer,
  deleteOfficer,
  getOfficer,
  getAllOfficers,
  getOfficerRanks,
} from "../../models/officers";
import DataTable from "react-data-table-component";
import i18n from "../../i18n";
import swal from "sweetalert";
import { Modal, Spinner } from "react-bootstrap";
import { HomeBanner } from "../home/homeBanner";
import FileInput from "../helpers/fileInput";
import { EditOfficer } from "./helper/edit_officer";
import { OfficerRanks } from "./helper/officer_ranks";

let lang = localStorage.getItem("I18N_LANGUAGE");
const customStyles = {
  headCells: {
    style: {
      fontWeight: "bold",
      backgroundColor: "#dadada",
      color: "#000000",
    },
  },
};

export class OfficersList extends React.Component {
  constructor() {
    super();
    this.state = {
      ranks: [],
      open_popup: false,
      update_popup: false,
      add: {
        country_code: "+968",
      },
      signature: null,
      data: {},
      errors: {},
      is_loading: false,
      users: {},
      hideSidebar: false,
      totalRows: 0,
      currentPage: 1,
      input: {
        page: 1,
        limit: 15,
      },
      columns: [
        {
          name: "ID",
          selector: "id",
          sortable: true,
          wrap: true,
          width: "50px",
        },
        {
          name: i18n.t("name"),
          cell: (row) => row.name,
          sortable: true,
        },
        {
          name: `${i18n.t("name")}(${i18n.t("arabic")})`,
          cell: (row) => row.name_ar,
          sortable: true,
        },
        {
          name: i18n.t("email"),
          cell: (row) => row.email,
        },
        {
          name: i18n.t("mobile"),
          wrap: true,
          cell: (row) => row.mobile,
        },
        {
          name: i18n.t("rank"),
          wrap: true,
          cell: (row) =>
            row.rank && row.rank_info
              ? lang === "ar"
                ? row?.rank_info?.rank_ar
                : row?.rank_info?.rank_en
              : "",
        },
        {
          name: i18n.t("signature"),
          wrap: true,
          cell: (row) =>
            row.signature ? <img src={row?.signature} alt="" width={70} /> : "",
        },
        {
          name: i18n.t("view"),
          button: true,
          cell: (row) => (
            <button
              className="btn btn-warning"
              onClick={(e) => {
                this.viewRow(row.id);
              }}
            >
              {i18n.t("view")}
            </button>
          ),
        },
        {
          name: i18n.t("delete"),
          button: true,
          cell: (row) => (
            <button
              className="btn btn-danger"
              onClick={(e) => {
                this.deleteRow(row.id);
              }}
            >
              {i18n.t("delete")}
            </button>
          ),
        },
      ],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleAddChange = this.handleAddChange.bind(this);
    this.triggerReload = this.triggerReload.bind(this);
    this.loadAllRanks = this.loadAllRanks.bind(this);
  }

  componentDidMount() {
    this.loadAllRanks();
    let input = this.state.input;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllUsers(qstring);
  }

  async loadAllRanks() {
    this.setState({ is_loading_ranks: true });
    const response = await getOfficerRanks("");
    let ranks = response.data;
    if (response.success) {
      this.setState({ is_loading_ranks: false });
      this.setState({ ranks: ranks });
    } else {
      this.setState({ is_loading_ranks: false });
    }
  }

  onFileChange = (event) => {
    if (event.target.name === "signature") {
      this.setState({ signature: event.target.files[0] });
    }
  };

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }
  handleAddChange(event) {
    let { add } = this.state;
    add[event.target.name] = event.target.value;
    this.setState({ add });
  }

  handleSearch(event) {
    let input = this.state.input;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllUsers(qstring);
  }

  async loadAllUsers(q) {
    this.setState({ is_loading: true });
    const response = await getAllOfficers(q);
    let users = response.data;
    let meta = response.meta;
    if (response.success) {
      this.setState({ is_loading: false });
      this.setState({ users: users });
      this.setState({ totalRows: meta.total });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async viewRow(id) {
    const response = await getOfficer(id);
    let data = response.data;
    this.setState({ data, update_popup: true });
  }

  handlePageChange = (page) => {
    let input = this.state.input;
    let currentPage = page;
    input["page"] = currentPage;
    this.setState({ currentPage: currentPage });
    this.setState({ input: input });
    let qstring = new URLSearchParams(input).toString();
    this.setState({ query: qstring });
    this.loadAllUsers(qstring);
  };

  async deleteRow(id) {
    var ans = window.confirm("Do you want to continue.?");
    if (ans) {
      const response = await deleteOfficer({ id: id });
      if (response.success) {
        swal(i18n.t("success"), "Officer deleted", "success", {
          buttons: false,
          timer: 2000,
        })
          .then((response) => {
            let { input } = this.state;
            let qstring = new URLSearchParams(input).toString();
            this.setState({ query: qstring });
            this.loadAllUsers(qstring);
          })
          .catch((response) => {
            swal("Failed", "Something went wrong", "error");
          });
      }
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.validate()) {
      try {
        const formData = new FormData();
        formData.append("name", this.state.add.name);
        formData.append("name_ar", this.state.add.name_ar);
        formData.append("mobile", this.state.add.mobile);
        formData.append("email", this.state.add.email);
        formData.append("username", this.state.add.username);
        formData.append("password", this.state.add.password);
        formData.append("rank", this.state.add.rank);
        formData.append("signature", this.state.signature);
        const response = await createOfficer(formData);
        if (response.success) {
          swal(i18n.t("success"), "Officer created successfully!!", "success", {
            buttons: false,
            timer: 2000,
          })
            .then((value) => {
              this.resetForm();
              let { input } = this.state;
              let q = new URLSearchParams(input).toString();
              this.loadAllUsers(q);
            })
            .catch((response) => {
              swal("Failed", response.message, "error");
            });
        } else {
          let error_message = response.message;
          let resObject = response.data;
          for (const key in resObject) {
            if (Object.hasOwnProperty.call(resObject, key)) {
              let element = resObject[key];
              error_message += "\n" + element;
            }
          }
          swal("Failed", error_message, "error");
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  resetForm() {
    let { add } = this.state;
    add["name"] = "";
    add["mobile"] = "";
    add["email"] = "";
    add["username"] = "";
    add["password"] = "";
    add["rank"] = "";
    this.setState({ add: add });
  }

  testMobile(phoneNumber) {
    let reg =
      "^(+|00)(9[976]d|8[987530]d|6[987]d|5[90]d|42d|3[875]d|2[98654321]d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)(s?d){9}$";
    var OK = reg.match(phoneNumber);
    if (!OK) {
      window.alert("phone number isn't  valid");
    } else {
      window.alert("phone number is  valid");
    }
  }

  validate() {
    let input = this.state.add;
    let errors = {};
    let isValid = true;
    if (!input["name"]) {
      isValid = false;
      errors["name"] = "Please enter your Name.";
    }
    if (!input["mobile"]) {
      isValid = false;
      errors["mobile"] = "Please enter your Phone Number.";
    }
    if (!input["username"]) {
      isValid = false;
      errors["username"] = "Please enter a valid Username.";
    }
    if (!input["password"]) {
      isValid = false;
      errors["password"] = "Please enter your Password.";
    }
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (!input["email"] || !pattern.test(input["email"])) {
      isValid = false;
      errors["email"] = "Please enter valid email address.";
    }
    if (!input["rank"]) {
      isValid = false;
      errors["rank"] = "Please select a rank.";
    }

    this.setState({
      errors: errors,
    });
    console.log(errors);
    return isValid;
  }

  triggerReload(opt) {
    if (opt) {
      let { input } = this.state;
      let qstring = new URLSearchParams(input).toString();
      this.loadAllUsers(qstring);
    }
  }

  render() {
    let { users, ranks } = this.state;
    return (
      <React.Fragment>
        <HomeBanner />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <div className="card mb-0">
                  <div className="card-header d-flex justify-content-between">
                    <div className=" d-flex">
                      <span
                        style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && (
                          <i className="icon-size-actual"></i>
                        )}
                        {!this.state.hideSidebar && (
                          <i className="icon-size-fullscreen"></i>
                        )}
                      </span>
                      <h3 className="card-title">{i18n.t("officers")}</h3>
                    </div>
                    <button
                      className="btn btn-dark"
                      onClick={(event) => {
                        this.setState({ open_popup: !this.state.open_popup });
                      }}
                    >
                      {i18n.t("add")} {i18n.t("officer")}
                    </button>
                    <button
                      className="btn btn-outline-dark"
                      onClick={() => {
                        this.setState({ rank_popup: true });
                      }}
                    >
                      {i18n.t("add")} {i18n.t("officer")} {i18n.t("ranks")}
                    </button>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive ">
                      {this.state.is_loading && (
                        <div className="text-center">
                          <Spinner animation="border" size="lg" />
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search by Name, email or phone"
                              name="qtext"
                              value={this.state.input.qtext}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <select
                              className="form-control"
                              name="rank"
                              value={this.state.input.rank}
                              onChange={this.handleChange}
                            >
                              <option value="">-- {i18n.t("rank")} --</option>
                              {ranks.map((item, i) => {
                                return (
                                  <option value={item.id} key={i}>
                                    {lang === "ar"
                                      ? item.rank_ar
                                      : item.rank_en}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="form-group">
                            <button
                              className="btn btn-primary"
                              onClick={this.handleSearch}
                            >
                              <i className="fa fa-search" />
                            </button>
                          </div>
                        </div>
                        {(this.state.input.qtext || this.state.input.rank) && (
                          <div className="col-md-1">
                            <div className="form-group">
                              <button
                                className="btn btn-outline-danger btn-block"
                                onClick={(e) => {
                                  let { input } = this.state;
                                  input.qtext = "";
                                  input.rank = "";
                                  this.setState({ input });
                                  this.handleSearch(e);
                                }}
                              >
                                <i className="fa fa-times" />
                              </button>
                            </div>
                          </div>
                        )}
                      </div>

                      {!this.state.is_loading && users.length > 0 && (
                        <div className="table-wrapper">
                          <DataTable
                            title=""
                            fixedHeader
                            columns={this.state.columns}
                            data={users}
                            customStyles={customStyles}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={this.state.totalRows}
                            paginationPerPage={15}
                            paginationDefaultPage={this.state.currentPage}
                            paginationRowsPerPageOptions={[15, 25, 50, 100]}
                            paginationComponentOptions={{
                              rowsPerPageText: i18n.t("users_per_page"),
                              rangeSeparatorText: i18n.t("out"),
                            }}
                            onChangePage={this.handlePageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Modal
          size="lg"
          show={this.state.open_popup}
          onHide={() => this.setState({ open_popup: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t("add")} {i18n.t("new")} {i18n.t("officer")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="single-page">
                <div className="col-md-12 d-block mx-auto">
                  <div className="wrapper wrapper2">
                    <form
                      id="Register"
                      className="card-body"
                      tabIndex="500"
                      autoComplete="off"
                    >
                      <div className="row">
                        <div className="col-sm-6 col-md-6">
                          <div className="form-group">
                            <label>{i18n.t("name")}</label>
                            <input
                              type="text"
                              name="name"
                              value={this.state.add.name}
                              onChange={this.handleAddChange}
                              autoComplete="name"
                              className="form-control custom-input "
                            />
                            <div className="text-danger">
                              {this.state.errors.name}
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6 col-md-6">
                          <div className="form-group">
                            <label>
                              {i18n.t("name")}({i18n.t("arabic")})
                            </label>
                            <input
                              type="text"
                              name="name_ar"
                              value={this.state.add.name_ar}
                              onChange={this.handleAddChange}
                              autoComplete="name"
                              style={{ direction: "rtl" }}
                              className="form-control custom-input rtl"
                            />
                            <div className="text-danger">
                              {this.state.errors.name}
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6 col-md-6">
                          <div className="form-group">
                            <label>{i18n.t("phone_number")}</label>
                            <div className="d-flex justify-content-between align-items-center">
                              <input
                                type="text"
                                className="form-control col-9"
                                name="country_code"
                                value={this.state.add.country_code}
                                disabled
                                style={{ width: "20%" }}
                              />
                              <input
                                type="text"
                                className="form-control col-9"
                                name="mobile"
                                value={this.state.add.mobile}
                                onChange={this.handleAddChange}
                                style={{ width: "80%" }}
                              />
                            </div>
                            <div className="text-danger">
                              {this.state.errors.mobile}
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6 col-md-6">
                          <div className="form-group">
                            <label>{i18n.t("email")}</label>
                            <input
                              type="text"
                              name="email"
                              value={this.state.add.email}
                              onChange={this.handleAddChange}
                              style={{ direction: "ltr" }}
                              className="form-control custom-input "
                            />
                            <div className="text-danger">
                              {this.state.errors.email}
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6 col-md-6">
                          <div className="form-group">
                            <label>{i18n.t("username")}</label>
                            <input
                              type="text"
                              name="username"
                              value={this.state.add.username}
                              onChange={this.handleAddChange}
                              autoComplete="username"
                              className="form-control custom-input "
                            />
                            <div className="text-danger">
                              {this.state.errors.username}
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6 col-md-6">
                          <div className="form-group">
                            <label>{i18n.t("password")}</label>
                            <input
                              type="text"
                              name="password"
                              value={this.state.add.password}
                              onChange={this.handleAddChange}
                              autoComplete="password"
                              className="form-control custom-input "
                            />
                            <div className="text-danger">
                              {this.state.errors.password}
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6 col-md-6">
                          <div className="form-group">
                            <label>{i18n.t("rank")}</label>
                            <select
                              className="form-control"
                              name="rank"
                              value={this.state.add.rank}
                              onChange={this.handleAddChange}
                            >
                              <option value="">-- {i18n.t("select")} --</option>
                              {ranks.map((item, i) => {
                                return (
                                  <option value={item.id} key={i}>
                                    {lang === "ar"
                                      ? item.rank_ar
                                      : item.rank_en}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="text-danger">
                              {this.state.errors.rank}
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6 col-md-6">
                          <div className="form-group">
                            <label className="form-label">
                              {i18n.t("signature")}
                            </label>
                            <FileInput
                              wrapperClass=""
                              placeholder={i18n.t("choose_file")}
                              id="signature"
                              name="signature"
                              onChange={this.onFileChange}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <button
                          type="button"
                          className="btn btn-primary btn-block mt-5"
                          onClick={this.handleSubmit}
                        >
                          {i18n.t("submit")}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          size="lg"
          show={this.state.update_popup}
          onHide={() => this.setState({ update_popup: false })}
          animation={true}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t("view")} {i18n.t("officer")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditOfficer
              data={this.state.data}
              ranks={ranks}
              lang={lang}
              triggerReload={this.triggerReload}
            />
          </Modal.Body>
        </Modal>

        <Modal
          size="lg"
          show={this.state.rank_popup}
          onHide={() => this.setState({ rank_popup: false })}
          animation={true}
          fullscreen={true}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t("officer")} {i18n.t("ranks")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <OfficerRanks triggerReloadRanks={this.loadAllRanks} />
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
